import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { ReactComponent as ArrowForward } from "images/arrowForward.svg";
import { LinkButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import TeamIllustrationSrc from "images/team-illustration-2.svg";
import VectorDesign from "images/Vector.svg";

const Container = tw.div`relative w-full`;
const FullWidthWrapper = tw.div`relative w-full overflow-hidden`;

const FullWidthImage = styled.img`
  ${tw`w-full object-cover`}
  height: 45vh;

  @media (max-width: 768px) {
    height: 45vh;
  }
`;

const Overlay = tw.div`
  absolute inset-0 bg-gradient-to-r from-black/25 via-black/75 to-black/15
`;

const OverlayTextWrapper = tw.div`
  absolute inset-0 flex flex-col items-center justify-center text-center px-6
`;

const OverlayHeading = tw.h1`
  text-white font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight
`;

const OverlaySubText = tw.p`
  text-white text-sm sm:text-lg mt-2 max-w-2xl
`;

const ButtonWrapper = tw.div`mt-5 flex flex-row justify-center items-center`;

const LinkButton = styled(PrimaryButtonBase)`
  ${tw`bg-white hover:bg-gray-100 flex gap-2 text-black rounded-full px-8 py-3 pb-1 outline-none border-none text-sm sm:text-base`}
`;

/* ✅ FIX: Define the Image component */
const IconImage = styled.img`
  ${tw`w-30 sm:w-32 mt-3 mb-2`}
`;

export default function HeroBanner({
  heading = "Build Your CA Career With Confidence",
  subheading = "Learn From India's Top Ranker Faculty",
  primaryButtonText = "Start Learning",
  primaryButtonUrl = "#",
  imageSrc = TeamIllustrationSrc,
  imageSrc1 = VectorDesign,
}) {
  return (
    <Container>
      <FullWidthWrapper>
        <FullWidthImage src={imageSrc} alt="banner" />

        <Overlay />

        <OverlayTextWrapper>
          <OverlayHeading>{heading}</OverlayHeading>

          {/* ✅ Using defined IconImage component */}
          <IconImage
            style={{ color: "#fff" }}
            src={imageSrc1}
            alt="vector icon"
          />

          <OverlaySubText>{subheading}</OverlaySubText>

          {primaryButtonText && (
            <ButtonWrapper>
              <LinkButton href={primaryButtonUrl}>
                {primaryButtonText} <ArrowForward className="ml-2" />
              </LinkButton>
            </ButtonWrapper>
          )}
        </OverlayTextWrapper>
      </FullWidthWrapper>
    </Container>
  );
}
